import { render, staticRenderFns } from "./bankModal.vue?vue&type=template&id=1f8ec85e"
import script from "./bankModal.vue?vue&type=script&lang=js"
export * from "./bankModal.vue?vue&type=script&lang=js"
import style0 from "./bankModal.vue?vue&type=style&index=0&id=1f8ec85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports